"use strict";

import axios from "axios";
import { BASE_URL } from "../constants/api";

export class TokenIcon {
  _api;
  _cache = JSON.parse(
    sessionStorage.getItem("token_icons") || JSON.stringify({})
  );

  constructor() {
    this._api = axios.create({
      baseURL: BASE_URL,
    });
  }

  async getIcon(address) {
    if (this._cache[address] !== undefined) return this._cache[address];

    const { data } = await this._api.get("api/tokens/token-icon", {
      params: { address },
    });

    this._cache[address] = data.logoUri;

    sessionStorage.setItem("token_icons", JSON.stringify(this._cache));

    return data?.logoUri;
  }
}

export const tokenIcon = new TokenIcon();
